import React, { useEffect, useState } from "react";
import "./LandingPageComponent.css";
import moment from "moment";
import { Apiurl, Encryption } from "../../Pages/utils/page";
import ProductCountdown from "../Countdown/Countdown";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { IoMdClose } from "react-icons/io";
import { BsShop } from "react-icons/bs";
import OurExclusivePartner from "../OurExclusivePartner/OurExclusivePartner";
import Slider from "react-slick";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import TopWinners from "../TopWinners/TopWinners";

const LandingPageComponent = ({
  categoriesData,
  bidAndDealProducts,
  categorySelected,
  loading,
  setLoading,
  setBannerIdData,
  bannerIdData,
  promotionalBanner,
  showCaseBanners,
  upprBanner,
  lowerBanner,
  leftMidBanner,
  rightMidBanner,
}) => {
  console.log(bidAndDealProducts, "bidAndDealProducts");
  const router = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <IoIosArrowForward />,
    prevArrow: <IoIosArrowBack />,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const [isMobileOrTablet, setIsMobileOrTablet] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;
      setIsMobileOrTablet(width <= 1024); // 320px to 1024px
    };

    checkDevice(); // Initial check
    window.addEventListener("resize", checkDevice); // Update on resize

    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  const settingsVendor = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 6,
    nextArrow: <IoIosArrowForward />,
    prevArrow: <IoIosArrowBack />,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  const settings1 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    arrows: false,
  };

  return (
    <div className="banner_section" style={{ flex: "1" }}>
      {/* <div className="background-bg-setion">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 mb_commn_pd_0">
                <div className="top-categories-section">
                  <div className="top-categories-align-center">
                    {categoriesData?.map((i) => {
                      return (
                        // <div
                        //   className={
                        //     categorySelected?.Id == i?.Id
                        //       ? "select-cat"
                        //       : "normal-cat"
                        //   }
                        // >
                        //   <p>{i?.CatgeoryName}</p>
                        // </div>
                        <div
                          class="normal-cat text-center cate-spc-mx hover-effect"
                          onClick={() => {
                            router(`/filter/${Encryption(i?.Id)}`);
                          }}
                        >
                          <img
                            src={`/Images/${i?.Id}.jpg`}
                            alt={i?.CatgeoryName}
                            className="img-hover"
                          />
                          <p>{i?.CatgeoryName}</p>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      <OurExclusivePartner
        setLoading={setLoading}
        setBannerIdData={setBannerIdData}
        bannerIdData={bannerIdData}
        promotionalBanner={promotionalBanner}
      />

      <div className="background-bg-setion">
        <div className="container-fluid">
          <div className="project-main-wraper">
            <div className="row">
              <div
                className={
                  !upprBanner?.length
                    ? "col-lg-12 mb_commn_pd_0"
                    : "col-lg-8 mb_commn_pd_0"
                }
              >
                <h4 class="common_heading">
                  Expiring Soon Bid Products<span class="pull-right"></span>
                </h4>
                <div className="product-section">
                  <div className="product-inner-pro-section">
                    <div className="row">
                      {bidAndDealProducts?.ExpiringSoonBidProducts?.length ? (
                        <>
                          {bidAndDealProducts?.ExpiringSoonBidProducts?.length >
                          4 ? (
                            <>
                              <Slider {...settings} className="expire-slicker">
                                {bidAndDealProducts?.ExpiringSoonBidProducts?.map(
                                  (item) => {
                                    const imagesArray = JSON.parse(
                                      item?.Images
                                    );

                                    const defaultImage = imagesArray.find(
                                      (img) => img.Default
                                    );

                                    const imageUrl = defaultImage
                                      ? `${Apiurl()}/${defaultImage.Images}`
                                      : "";
                                    const now = moment(); // Current time
                                    const timeTo = moment(item?.ToPushlishDate);
                                    const timeDifferenceInHours = timeTo.diff(
                                      now,
                                      "hours"
                                    );
                                    return (
                                      <div className="col-lg-3 col-6 card-main-slick">
                                        <div className="product-card">
                                          <img
                                            src={imageUrl}
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "/Images/no-product-img-700.jpg";
                                            }}
                                            onClick={() => {
                                              router(
                                                `/productdetail/${Encryption(
                                                  item?.Id
                                                )}`
                                              );
                                            }}
                                          />

                                          <h2>{item?.ProductName} </h2>
                                          <div>
                                            {timeDifferenceInHours > 24 ? (
                                              <p>
                                                Till:{" "}
                                                {moment(
                                                  item?.ToPushlishDate
                                                ).format("LL")}
                                              </p>
                                            ) : (
                                              <p>
                                                <ProductCountdown
                                                  item={item}
                                                  val="tillTime"
                                                />
                                              </p>
                                            )}

                                            <h5>₹ {item?.Mrp}</h5>
                                            {item?.IsProductOutOfStock ===
                                            true ? (
                                              <input
                                                type="button"
                                                value="Out of Stock"
                                                className="common_btn_new out_stock_btn_01"
                                              />
                                            ) : (
                                              <input
                                                type="button"
                                                onClick={() => {
                                                  router(
                                                    `/productdetail/${Encryption(
                                                      item?.Id
                                                    )}`
                                                  );
                                                }}
                                                value={
                                                  item?.IsProductInOffer == true
                                                    ? "Bid Now"
                                                    : item?.IsProductInOffer ==
                                                      false
                                                    ? "Buy Now"
                                                    : item?.IsProductInOffer ==
                                                      null
                                                    ? "Contact Us"
                                                    : null
                                                }
                                                className={
                                                  item?.IsProductInOffer == true
                                                    ? "common_btn_new bid_now_btn_01 bid-now-home-page"
                                                    : item?.IsProductInOffer ==
                                                      false
                                                    ? "common_btn_new bid-now-home-page"
                                                    : item?.IsProductInOffer ==
                                                      null
                                                    ? "common_btn_new bid-now-home-page"
                                                    : null
                                                }
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </Slider>
                            </>
                          ) : (
                            <>
                              {bidAndDealProducts?.ExpiringSoonBidProducts?.map(
                                (item) => {
                                  const imagesArray = JSON.parse(item?.Images);

                                  const defaultImage = imagesArray.find(
                                    (img) => img.Default
                                  );

                                  const imageUrl = defaultImage
                                    ? `${Apiurl()}/${defaultImage.Images}`
                                    : "";
                                  const now = moment(); // Current time
                                  const timeTo = moment(item?.ToPushlishDate);
                                  const timeDifferenceInHours = timeTo.diff(
                                    now,
                                    "hours"
                                  );
                                  return (
                                    <div className="col-lg-3 col-6 card-main-slick">
                                      <div className="product-card">
                                        <img
                                          src={imageUrl}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/Images/no-product-img-700.jpg";
                                          }}
                                          onClick={() => {
                                            router(
                                              `/productdetail/${Encryption(
                                                item?.Id
                                              )}`
                                            );
                                          }}
                                        />
                                        <h2>{item?.ProductName} </h2>

                                        {timeDifferenceInHours > 24 ? (
                                          <p>
                                            Till:{" "}
                                            {moment(
                                              item?.ToPushlishDate
                                            ).format("LL")}
                                          </p>
                                        ) : (
                                          <p>
                                            <ProductCountdown
                                              item={item}
                                              val="tillTime"
                                            />
                                          </p>
                                        )}

                                        <h5>₹ {item?.Mrp}</h5>
                                        {item?.IsProductOutOfStock === true ? (
                                          <input
                                            type="button"
                                            value="Out of Stock"
                                            className="common_btn_new out_stock_btn_01"
                                          />
                                        ) : (
                                          <input
                                            type="button"
                                            onClick={() => {
                                              router(
                                                `/productdetail/${Encryption(
                                                  item?.Id
                                                )}`
                                              );
                                            }}
                                            value={
                                              item?.IsProductInOffer == true
                                                ? "Bid Now"
                                                : item?.IsProductInOffer ==
                                                  false
                                                ? "Buy Now"
                                                : item?.IsProductInOffer == null
                                                ? "Contact Us"
                                                : null
                                            }
                                            className={
                                              item?.IsProductInOffer == true
                                                ? "common_btn_new bid_now_btn_01 bid-now-home-page"
                                                : item?.IsProductInOffer ==
                                                  false
                                                ? "common_btn_new bid-now-home-page"
                                                : item?.IsProductInOffer == null
                                                ? "common_btn_new bid-now-home-page"
                                                : null
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <div className="product-section">
                          <div className="empty-state center-middle">
                            <p>
                              We don’t have any products to show at the moment.
                              Keep an eye out for updates!
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {upprBanner?.length && (
                <div className="col-lg-4 mb_commn_pd_0">
                  <div className="product-inner-pro-section">
                    <Slider {...settings1} className="expire-slicker">
                      {upprBanner?.map((item, index) => {
                        const image = item?.BannerSrc?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[1]}`;

                        return (
                          item?.IsPublish && (
                            <img
                              className="side-banner-img"
                              key={index}
                              src={imageURL}
                              alt="Side Banner"
                            />
                          )
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="background-bg-setion">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <h4 class="common_heading">
                Exclusive Top Merchants<span class="pull-right"></span>
              </h4>
              <div className="row">
                <div className="col-lg-12 mb_commn_pd_0">
                  <div className="exclusive-main-wraper">
                    {showCaseBanners ? (
                      <div className="exclusive-inner-pro-section">
                        <div className="row">
                          {showCaseBanners.length > 6 || isMobileOrTablet ? (
                            <Slider
                              {...settingsVendor}
                              className="expire-slicker"
                            >
                              {showCaseBanners.map((item, idx) => {
                                const image = item?.BannerSrc?.split('"');
                                const imageURL = `${Apiurl()}/${image?.[1]}`;
                                return (
                                  <div
                                    key={idx}
                                    className="col-lg-2 col-6 card-main-slick"
                                    onClick={() =>
                                      router(
                                        `/vendorproductsdetail/${Encryption(
                                          item?.VendorId
                                        )}`
                                      )
                                    }
                                  >
                                    <p>{item?.OfferDescription}</p>
                                    <img src={imageURL} alt="" />
                                    <a href="">See more...</a>
                                  </div>
                                );
                              })}
                            </Slider>
                          ) : (
                            showCaseBanners.map((item, idx) => {
                              const image = item?.BannerSrc?.split('"');
                              const imageURL = `${Apiurl()}/${image?.[1]}`;
                              return (
                                <div
                                  key={idx}
                                  className="col-lg-2 col-6 card-main-slick"
                                  onClick={() =>
                                    router(
                                      `/vendorproductsdetail/${Encryption(
                                        item?.VendorId
                                      )}`
                                    )
                                  }
                                >
                                  <p>{item?.OfferDescription}</p>
                                  <img src={imageURL} alt="" />
                                  <a href="">See more...</a>
                                </div>
                              );
                            })
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="banner-row exclusive-inner-pro-section h5-text-in-no text-center">
                        <h5>No banners available yet</h5>
                        <p>
                          Stay tuned—exciting new merchants are coming soon!
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="background-bg-setion">
        <div className="container-fluid">
          <div className="project-main-wraper">
            <div className="row">
              <div
                className={
                  !lowerBanner?.length
                    ? "col-lg-12 mb_commn_pd_0"
                    : "col-lg-8 mb_commn_pd_0"
                }
              >
                <h4 class="common_heading">
                  Expiring Soon Deal Products<span class="pull-right"></span>
                </h4>

                <div className="product-section">
                  <div className="product-inner-pro-section">
                    <div className="row">
                      {bidAndDealProducts?.BestDealProducts?.length ? (
                        <>
                          {bidAndDealProducts?.BestDealProducts?.length > 4 ? (
                            <>
                              <Slider {...settings} className="expire-slicker">
                                {bidAndDealProducts?.BestDealProducts?.map(
                                  (item) => {
                                    const imagesArray = JSON.parse(
                                      item?.Images
                                    );

                                    const defaultImage = imagesArray.find(
                                      (img) => img.Default
                                    );

                                    const imageUrl = defaultImage
                                      ? `${Apiurl()}/${defaultImage.Images}`
                                      : "";
                                    const now = moment(); // Current time
                                    const timeTo = moment(item?.ToPushlishDate);
                                    const timeDifferenceInHours = timeTo.diff(
                                      now,
                                      "hours"
                                    );
                                    return (
                                      <div className="col-lg-3 col-6 card-main-slick">
                                        <div className="product-card">
                                          <img
                                            src={imageUrl}
                                            onError={(e) => {
                                              e.target.onerror = null;
                                              e.target.src =
                                                "/Images/no-product-img-700.jpg";
                                            }}
                                            onClick={() => {
                                              router(
                                                `/productdetail/${Encryption(
                                                  item?.Id
                                                )}`
                                              );
                                            }}
                                          />
                                          <h2>{item?.ProductName} </h2>

                                          {timeDifferenceInHours > 24 ? (
                                            <p>
                                              Till:{" "}
                                              {moment(
                                                item?.ToPushlishDate
                                              ).format("LL")}
                                            </p>
                                          ) : (
                                            <p>
                                              <ProductCountdown
                                                item={item}
                                                val="tillTime"
                                              />
                                            </p>
                                          )}

                                          <h5>
                                            {" "}
                                            ₹ {item?.DealPrice}{" "}
                                            <span className="mrp-price">
                                              ₹{item?.Mrp}
                                            </span>
                                            <span className="flat-dicsount">
                                              {" "}
                                              {Math.round(
                                                ((item.Mrp - item.DealPrice) /
                                                  item.Mrp) *
                                                  100
                                              )}
                                              % off
                                            </span>
                                          </h5>
                                          {item?.IsProductOutOfStock ===
                                          true ? (
                                            <input
                                              type="button"
                                              value="Out of Stock"
                                              className="common_btn_new out_stock_btn_01"
                                            />
                                          ) : (
                                            <input
                                              type="button"
                                              onClick={() => {
                                                router(
                                                  `/productdetail/${Encryption(
                                                    item?.Id
                                                  )}`
                                                );
                                              }}
                                              value={
                                                item?.IsProductInOffer == true
                                                  ? "Bid Now"
                                                  : item?.IsProductInOffer ==
                                                    false
                                                  ? "Buy Now"
                                                  : item?.IsProductInOffer ==
                                                    null
                                                  ? "Contact Us"
                                                  : null
                                              }
                                              className={
                                                item?.IsProductInOffer == true
                                                  ? "common_btn_new bid_now_btn_01 bid-now-home-page"
                                                  : item?.IsProductInOffer ==
                                                    false
                                                  ? "common_btn_new bid-now-home-page"
                                                  : item?.IsProductInOffer ==
                                                    null
                                                  ? "common_btn_new bid-now-home-page"
                                                  : null
                                              }
                                            />
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </Slider>
                            </>
                          ) : (
                            <>
                              {bidAndDealProducts?.BestDealProducts?.map(
                                (item) => {
                                  const imagesArray = JSON.parse(item?.Images);

                                  const defaultImage = imagesArray.find(
                                    (img) => img.Default
                                  );

                                  const imageUrl = defaultImage
                                    ? `${Apiurl()}/${defaultImage.Images}`
                                    : "";
                                  const now = moment(); // Current time
                                  const timeTo = moment(item?.ToPushlishDate);
                                  const timeDifferenceInHours = timeTo.diff(
                                    now,
                                    "hours"
                                  );
                                  return (
                                    <div className="col-lg-3 col-6 card-main-slick">
                                      <div className="product-card">
                                        <img
                                          src={imageUrl}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src =
                                              "/Images/no-product-img-700.jpg";
                                          }}
                                          onClick={() => {
                                            router(
                                              `/productdetail/${Encryption(
                                                item?.Id
                                              )}`
                                            );
                                          }}
                                        />
                                        <h2>{item?.ProductName} </h2>

                                        {timeDifferenceInHours > 24 ? (
                                          <p>
                                            Till:{" "}
                                            {moment(
                                              item?.ToPushlishDate
                                            ).format("LL")}
                                          </p>
                                        ) : (
                                          <p>
                                            <ProductCountdown
                                              item={item}
                                              val="tillTime"
                                            />
                                          </p>
                                        )}

                                        <h5>
                                          {" "}
                                          ₹ {item?.DealPrice}{" "}
                                          <span className="mrp-price">
                                            ₹{item?.Mrp}
                                          </span>
                                          <span className="flat-dicsount">
                                            {" "}
                                            {Math.round(
                                              ((item.Mrp - item.DealPrice) /
                                                item.Mrp) *
                                                100
                                            )}
                                            % off
                                          </span>
                                        </h5>
                                        {item?.IsProductOutOfStock === true ? (
                                          <input
                                            type="button"
                                            value="Out of Stock"
                                            className="common_btn_new out_stock_btn_01"
                                          />
                                        ) : (
                                          <input
                                            type="button"
                                            onClick={() => {
                                              router(
                                                `/productdetail/${Encryption(
                                                  item?.Id
                                                )}`
                                              );
                                            }}
                                            value={
                                              item?.IsProductInOffer == true
                                                ? "Bid Now"
                                                : item?.IsProductInOffer ==
                                                  false
                                                ? "Buy Now"
                                                : item?.IsProductInOffer == null
                                                ? "Contact Us"
                                                : null
                                            }
                                            className={
                                              item?.IsProductInOffer == true
                                                ? "common_btn_new bid_now_btn_01 bid-now-home-page"
                                                : item?.IsProductInOffer ==
                                                  false
                                                ? "common_btn_new bid-now-home-page"
                                                : item?.IsProductInOffer == null
                                                ? "common_btn_new "
                                                : null
                                            }
                                          />
                                        )}
                                      </div>
                                    </div>
                                  );
                                }
                              )}
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          <div className="product-section">
                            <div className="empty-state center-middle">
                              <p>
                                We don’t have any products to show at the
                                moment. Keep an eye out for updates!
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              {lowerBanner?.length && (
                <div className="col-lg-4 mb_commn_pd_0">
                  <div className="product-inner-pro-section">
                    <Slider {...settings1} className="expire-slicker">
                      {lowerBanner?.map((item, index) => {
                        const image = item?.BannerSrc?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[1]}`;

                        return (
                          item?.IsPublish && (
                            <img
                              className="side-banner-img"
                              key={index}
                              src={imageURL}
                              alt="Side Banner"
                            />
                          )
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="background-bg-setion">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <div className="prom-ads-wraper">
                <div className="banner-carousel-container d-flex">
                  <div className="banner-carousel ">
                    <Slider {...settings1} className="expire-slicker">
                      {leftMidBanner?.map((item, index) => {
                        const image = item?.BannerSrc?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[1]}`;

                        return (
                          item?.IsPublish && (
                            <img
                              className="side-banner-img"
                              key={index}
                              src={imageURL}
                              alt="Side Banner"
                            />
                          )
                        );
                      })}
                    </Slider>
                  </div>
                  <div className="banner-carousel ">
                    <Slider {...settings1} className="expire-slicker">
                      {rightMidBanner?.map((item, index) => {
                        const image = item?.BannerSrc?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[1]}`;

                        return (
                          item?.IsPublish && (
                            <img
                              className="side-banner-img"
                              key={index}
                              src={imageURL}
                              alt="Side Banner"
                            />
                          )
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {promotionalBanner?.FullBanners?.length && (
        <div className="background-bg-setion">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 mb_commn_pd_0">
                <div className="full-btm-pro-banner-section">
                  <Slider {...settings1} className="expire-slicker">
                    {promotionalBanner?.FullBanners?.map((item) => {
                      const image = item?.BannerSrc?.split('"');
                      const imageURL = `${Apiurl()}/${image?.[1]}`;
                      return (
                        <img
                          className="Banner-image"
                          src={imageURL}
                          layout="intrinsic"
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "/Images/banner-default.jpg";
                          }}
                        />
                      );
                    })}
                  </Slider>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="top-winners background-bg-setion">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 mb_commn_pd_0">
              <TopWinners />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPageComponent;
